import {cardTitle, primaryColor, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import {specialScrollbar} from "assets/jss/special-scrollbar.jsx";
import modelosStyle from "./modelosStyle";
import customInfoLabels from "../customInfoLabels";

const cursosStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  tooltip,
  ...customInfoLabels,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  cursosContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  modalCardTitle: {
    fontSize: "20px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  addForm: {
    padding: "0 10px"
  },
  tableActions: {
    float: "right"
  },
  tableActionsCurso: {
    float: "right",
    marginTop: "-45px"
  },
  formacaoActions: {
    "&>button": {
      marginLeft: "10px"
    }
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  addCourseButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  novoCursoForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  buttons: {
    float: "right",
    "&>button": {
      marginLeft: "10px"
    }
  },
  clickableLink: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  formandoEstadoAprovado: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#30af48",
    color: "white"
  },
  formandoEstadoReprovado: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#af2a32",
    color: "white"
  },
  formandoEstadoPorAvaliarFrequentar: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#8c8c8c",
    color: "white"
  },
  formandoEstadoPorFrequentar: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "grey",
    color: "white"
  },
  formandoEstadoDarFeedback: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#00acc1",
    color: "white"
  },
  formandoEstadoInscricaoAprovar: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#ffa21a",
    color: "white"
  },
  formadorCaixa: {
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#30af48",
    color: "white",
    display: "inline-block",
    marginBottom: "10px"
  },
  formadorLabel: {
    display: "block",
    marginBottom: "5px"
  },
  personBox: {
    "&>span": {
      display: "block"
    }
  },
  percursoActions: {
    textAlign: "center",
    paddingTop: "30px"
  },
  placeholderMap: {
    height: "330px",
    cursor: "pointer",
    backgroundPosition: "center",
    backgroundSize: "cover",
    borderRadius: "10px",
    textAlign: "center",
    "&:hover": {
      opacity: "0.8"
    },
    "&:active": {
      transform: "scale(0.98)",
      transition: "all 0.08s ease-out"
    },
    "&>span": {
      height: "100px",
      width: "100px",
      backgroundColor: "#ffffffb3",
      borderRadius: "50%",
      display: "inline-block",
      marginTop: "115px",
      "&>svg": {
        fontSize: "100px"
      }
    }
  },
  formacaoPostWrapper: {
    overflow: "auto",
    maxHeight: "350px",
    ...specialScrollbar
  },
  formacaoPost: {
    display: "block",
    marginRight: 5,
    "&:not(:last-child)": {
      paddingBottom: "6px",
      borderBottom: "1px solid #d8d8d8"
    }
  },
  formacaoPostData: {
    display: "block",
    textAlign: "right"
  },
  userCaixa: {
    "&:hover": {
      backgroundColor: "#007c39",
      textDecoration: "underline"
    },
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#30af48",
    color: "white",
    display: "inline-block !important",
    marginBottom: "10px",
    cursor: "pointer"
  },
  userDetails: {
    fontSize: "11px",
    color: "#494949"
  },
  userLabel: {
    display: "block",
    marginBottom: "5px"
  },
  courseDetails: {
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    }
  },
  editObservacoesButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right",
    color: "#f78200",
    "&:hover, &:focus": {
      color: "#ef7c00"
    }
  },
  cursoButtons: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  moduloCard: modelosStyle.moduloCard,
  moduloCardBody: modelosStyle.moduloCardBody,
  innerCardTitle: modelosStyle.innerCardTitle,
  areaContentGrid: modelosStyle.areaContentGrid,
  addModuloButton: modelosStyle.addModuloButton,
  formacoesUltimaColuna: {
    width: 100
  },
  itemDetalhes: {
    textAlign: "center",
    margin: "18px 0",
    "& h4": {
      margin: 0
    },
    "& p": {
      margin: 0,
      marginTop: 5,
      fontSize: 13,
      textTransform: "uppercase"
    }
  },
  outrosDetalhes: {
    marginTop: 20,
    "& h4": {
      borderBottom: "solid #35ab50 2px",
      display: "inline-block",
      minWidth: "60%"
    }
  },
  modulosAreaHeaderContainer: {
    padding: "15px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  modulosAreaHeaderTypeLabel: {
    backgroundColor: "#dc9e20",
    padding: "4px 10px",
    color: "white",
    borderRadius: "6px",
    textTransform: "uppercase",
    fontSize: "12px",
    marginLeft: "10px"
  },
  modulosParticipanteAccordionWrapper: {
    padding: 20,
    backgroundColor: "#edf8fb",
    boxShadow: "inset 0px 35px 10px -30px rgba(0,0,0,0.05), inset 0px -35px 10px -30px rgba(0,0,0,0.05)"
  },
  modulosCardContainer: {
    border: "solid 1px #eaeaea",
    padding: "5px 10px",
    position: "relative",
    boxShadow: "2px 3px 7px 1px #00000008",
    borderRadius: 4,
    marginBottom: 10,
    minHeight: 55,
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modulosCardTitle: {
    fontSize: 14,
    textAlign: "center",
    margin: 0
  },
  modulosFormacaoContainer: {
    position: "relative",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    padding: "10px 15px",
    boxShadow: "2px 3px 7px 1px #00000008",
    border: "solid 1px #eaeaea",
    marginBottom: "10px"
  },
  modulosFormacaoTitle: {
    fontSize: "18px",
    paddingTop: "2px",
    textAlign: "center"
  },
  modulosFormacaoSubtitle: {
    fontSize: "12px",
    textTransform: "uppercase",
    textAlign: "center",
    marginTop: -6
  },
  modulosFormacaoPrice: {
    fontSize: "12px",
    fontWeight: "400",
    borderRadius: "4px",
    backgroundColor: "#f1f1f1",
    padding: "1px 5px",
    width: "fit-content"
  },
  modulosFormacaoViewButton: {
    borderRadius: "4px",
    padding: "4px 12px"
  },
  modulosFormacaoRibbon: {
    position: "absolute",
    top: "-6.1px",
    right: "10px",
    "&:after": {
      position: "absolute",
      content: "''",
      width: "0",
      height: "0",
      borderLeft: "45px solid transparent",
      borderRight: "45px solid transparent",
      borderTop: "10px solid #38B449"
    },
    "& span": {
      position: "relative",
      display: "block",
      textAlign: "center",
      background: "linear-gradient(180deg, #018a41, #38B449)",
      fontSize: "11px",
      color: "white",
      lineHeight: "1",
      padding: "10px 8px 6px",
      borderTopRightRadius: "8px",
      width: "90px",
      "&:after": {
        position: "absolute",
        content: "''",
        height: "6px",
        width: "8px",
        left: "-8px",
        top: "0",
        borderRadius: "8px 8px 0 0",
        background: "linear-gradient(60deg, #007536, #004e0b)"
      },
      "&:before": {
        position: "absolute",
        content: "''",
        height: "6px",
        width: "6px",
        left: "-6px",
        top: "0",
        background: "#018a41"
      }
    }
  },
  eventLabel: {
    textAlign: "center",
    "& h2": {
      margin: 0
    },
    "& p": {
      textTransform: "uppercase",
      margin: 0,
      fontWeight: 500,
      fontSize: 21,
    }
  },
  buttonAnterior: {
    padding: "5px 12px 5px 10px!important",
    marginRight: "auto",
  },
  buttonSeguinte: {
    padding: "5px 12px 5px 10px!important",
  },

  // Switch do popup do Moodle na cor do tema: o MUI não tem theme provider configurado,
  // por isso o color="primary" nativo sairia azul
  switchMoodle: {
    "& .MuiSwitch-colorSecondary.Mui-checked": {
      color: primaryColor
    },
    "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
      backgroundColor: primaryColor
    }
  },
};

export default cursosStyle;
